import { render, staticRenderFns } from "./DotsPatient.vue?vue&type=template&id=75a2a2ba&scoped=true"
import script from "./DotsPatient.vue?vue&type=script&lang=js"
export * from "./DotsPatient.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75a2a2ba",
  null
  
)

export default component.exports